import {
  makeRouteLinkBuilder,
  makeUseTypedNavigate,
  makeUseTypedParams,
} from 'utils/routeLink/makeRouteObject'

import { RoutesData } from './router'
import { typedRouting } from './typedRouting'

typedRouting.useNavigate = makeUseTypedNavigate(RoutesData.routes)
typedRouting.useParams = makeUseTypedParams(RoutesData.routes)
typedRouting.linkBuilder = makeRouteLinkBuilder(RoutesData.routes)
